import { render } from "./EventCalendar.vue?vue&type=template&id=541fd357"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"

import "./EventCalendar.vue?vue&type=style&index=0&id=541fd357&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__